import { APP, APP_PLATFORM } from 'libs/constants';
import apiCall from './apiRequest';
import endPoints from './endpoints';

const DIRECT_PLANS_CA_ANDROID = {
  plans: [
    {
      title: 'views.directPlans.android.directPlansItemsWrapper.annual.CA.title',
      tax: null,
      planID: 'ca-direct-android-annual',
      currency: 'CAD',
      offer: 'views.directPlans.android.directPlansItemsWrapper.annual.CA.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 30.99
    },
    {
      title: 'views.directPlans.android.directPlansItemsWrapper.monthly.CA.title',
      planID: 'ca-direct-android-monthly',
      currency: 'CAD',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 4.99,
      tax: null
    }
  ]
};

const DIRECT_PLANS_US_ANDROID = {
  plans: [
    {
      title: 'views.directPlans.android.directPlansItemsWrapper.annual.US.title',
      tax: null,
      planID: 'us-direct-android-annual',
      currency: 'USD',
      offer: 'views.directPlans.android.directPlansItemsWrapper.annual.US.offer',
      isRecommended: true,
      isSelected: true,
      frequency: 'Annual',
      amount: 23.99
    },
    {
      title: 'views.directPlans.android.directPlansItemsWrapper.monthly.US.title',
      planID: 'us-direct-android-monthly',
      currency: 'USD',
      isRecommended: false,
      isSelected: false,
      frequency: 'Monthly',
      amount: 3.99,
      tax: null
    },
  ]
};

export function fetchDirectPlansAndroidApi(countryCode) {
  let Plans = DIRECT_PLANS_US_ANDROID;
  if (countryCode && countryCode.toUpperCase() === 'CA') {
    Plans = DIRECT_PLANS_CA_ANDROID;
  }
  return Promise.resolve(Plans);
}

export function checkoutDirectPlanAndroidApi(plan, locale) {
  return apiCall({
    method: 'put',
    endpoint: endPoints.planCheckout,
    payload: {
      app: APP.direct,
      platform: APP_PLATFORM.android,
      plan,
    },
    query: {
      locale
    }
  });
}

export default {
  fetchDirectPlansAndroidApi
};



// WEBPACK FOOTER //
// ./src/api/directAndroidPlans.js